<div class="d-flex"><highcharts-chart class="trend_chart" [Highcharts]="Highcharts" [(update)]="updateFlag" [options]="chartOptions"></highcharts-chart></div>